import { FC } from 'react'
import classNames from 'classnames'

import { CarouselContainerProps } from './types'

export const Container: FC<CarouselContainerProps> = ({
  className,
  ...props
}) => <ul className={classNames('grid grid-flow-col', className)} {...props} />
